import { createDraftSafeSelector } from '@reduxjs/toolkit';
import { URN } from '@youhelp-ru/core';
import { authenticationTokenPayloadSelector } from '@cp/shared/api/core';
import { User, UserType } from '../../user';

const initialState = { id: 0, type: UserType.Guest };

export const currentUserSelector = createDraftSafeSelector(authenticationTokenPayloadSelector, (payload): User => {
  if (!payload || !URN.canParse(payload.sub)) {
    return initialState;
  }
  // TODO: use UserToken class
  const { nss } = URN.parse(payload.sub);
  const [type, id] = nss.split(':');

  switch (type) {
    case 'admin':
      return {
        type: UserType.Admin,
        id: Number.parseInt(id),
      };
    case 'client':
      return {
        id: Number.parseInt(id),
        type: UserType.Client,
      };
    default:
      return initialState;
  }
});
